var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAppleLogo = function SvgAppleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 30c1.8 0 2.6-1.2 4.9-1.2 2.3 0 2.8 1.2 4.8 1.2s3.3-1.9 4.6-3.7c1.4-2.1 2-4.2 2-4.3-.1 0-3.9-1.6-3.9-6.1 0-3.9 3-5.6 3.2-5.7-2-2.9-5-3-5.8-3-2.2 0-4 1.4-5.2 1.4s-2.9-1.3-4.8-1.3c-3.7 0-7.4 3.1-7.4 8.9 0 3.6 1.4 7.5 3.1 9.9 1.3 2.2 2.6 3.9 4.5 3.9m4.7-23.1c1.3 0 3-.9 4-2.1.9-1.1 1.6-2.7 1.6-4.2 0-.2 0-.4-.1-.6-1.5.1-3.3 1-4.3 2.3-.8 1-1.6 2.5-1.6 4.1 0 .2 0 .5.1.5h.3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })));
};
export default SvgAppleLogo;